const {sanitizeToCssPx} = require("../../js_common/_dzs_helpers");
var defaultOptions = require('./configs/_navigationSettings').defaultSettings;

class DzsNavigation {

  constructor(parentClass, argOptions, $) {

    // console.log('defaultOptions - ', defaultOptions);
    this.$ = $;
    this.parentClass = parentClass;
    this.initOptions = Object.assign(defaultOptions, argOptions);
    this.$mainNavigation = null;
    this.$clippedContainer = null;

    this.initClass();

  }

  initClass() {
    const selfClass = this;
    const parentClass = this.parentClass;
    let menu_position = selfClass.initOptions.menuPosition;
    const initOptions = this.initOptions;


    // console.log(selfClass.initOptions);


    setupStructure();

    function setupStructure() {


      var aux_main_navigation_str = '<div class="main-navigation dzs-navigation--type-' + selfClass.initOptions.navigationType + '"><div class="navMain videogallery--navigation--clipped-container navigation--clipped-container"><div class="videogallery--navigation-container navigation--total-container">';
      aux_main_navigation_str += '</div></div></div>';

      parentClass.$navigationAndMainArea.addClass(`navPosition-${menu_position}`);

      parentClass.$navigationAndMainArea.append('<div class="sliderMain media--main-area"><div class="sliderCon"></div></div>');
      parentClass.$navigationAndMainArea.append(aux_main_navigation_str);



      selfClass.$mainNavigation = parentClass.$navigationAndMainArea.find('.main-navigation');
      selfClass.$clippedContainer = selfClass.$mainNavigation.find('.navigation--clipped-container');


      if(initOptions.menuItemWidth==='default'){
        initOptions.menuItemWidth = '';
      }
      if(initOptions.menuItemHeight==='default'){
        initOptions.menuItemHeight = '';
      }

      if(menu_position==='right' || menu_position==='left'){
        if(initOptions.menuItemWidth){

          // console.log('initOptions.menuItemWidth - ', initOptions.menuItemWidth, ' selfClass.$mainNavigation- ' , selfClass.$mainNavigation);
          selfClass.$mainNavigation.css({
            'flex': `0 0 ${sanitizeToCssPx(initOptions.menuItemWidth)}`
          })
        }
      }

      if(menu_position==='top' || menu_position==='bottom'){

      }

    }
  }

  calculateDims(){
    const selfClass = this;
    let menu_position = selfClass.initOptions.menuPosition;
    const parentClass = this.parentClass;

    let totalAreaPixels = 0;

    parentClass.$navigationAndMainArea.children().each(function(){
      var $t = jQuery(this);

      totalAreaPixels+=$t.get(0).scrollHeight;
    })

    if(menu_position==='top' || menu_position==='bottom'){

      // todo: move
      parentClass.$navigationAndMainArea.css({
        height: totalAreaPixels+'px'
      })
    }
  }
}

exports.DzsNavigation = DzsNavigation;